module.exports = __webpack_public_path__ + "media/images/banner-fede1fbbf17cff2eb97628dacfa443bd.png";